import * as helpers from "./helpers";

const defaultListReducerForGeofondImports = helpers.createListReducer({listViewName: 'geofond_imports', actionsName: 'geofond_imports'})
const defaultEditReducerForGeofondImports = helpers.createEditReducer({editViewName: 'geofond_imports', actionsName: 'geofond_imports'})
export const geofond_imports = (state = helpers.listEditGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here

    const stateAfterList = defaultListReducerForGeofondImports({state, type, payload, reqId})
    return defaultEditReducerForGeofondImports({state: stateAfterList, type, payload, reqId})
}